export * from './adapter-article.module';
export * from './adapter-article.pipe';
